import { render } from "./PatientHeader.vue?vue&type=template&id=62223c3c"
import script from "./PatientHeader.vue?vue&type=script&lang=js"
export * from "./PatientHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__